import {
  loadFuturesReferenceData,
  loadSwapReferenceData,
  loadTradeFromScratchReferenceData,
} from "@/components/widgets/tradeFromScratch/helper/tradeFromScratchHelper";
import { returnTicketInstruments } from "@/components/widgets/tradeFromScratch/ticketFields/InstrumentSelect";
import { addDraftLeg } from "@/store/draftLegsStoreACTIONS";
import { TicketInstrument } from "@/store/tradeFromScratchStore";

// LQC-2941 - the "+" that starts a draft leg. In the toolbar rather than under the list
// so it never scrolls away (LEG_CREATION_PLAN Q18). Only rendered while tradeCreationLegs
// is on, so every instrument, Repo included, is offered.
interface IDraftLegAddButton {
  widgetId: string;
  getAccessTokenSilently: Function;
  onAdded: (draftId: string) => void;
}

const DraftLegAddButton = ({
  widgetId,
  getAccessTokenSilently,
  onAdded,
}: IDraftLegAddButton) => {
  const handleAdd = (instrument: TicketInstrument) => {
    // Fetch-once: Leg Creation may not be open to have loaded them.
    loadTradeFromScratchReferenceData(getAccessTokenSilently);
    if (instrument === TicketInstrument.Future) {
      loadFuturesReferenceData(getAccessTokenSilently);
    }
    if (
      instrument === TicketInstrument.Swap ||
      instrument === TicketInstrument.Swaption
    ) {
      loadSwapReferenceData(getAccessTokenSilently);
    }
    onAdded(addDraftLeg(widgetId, instrument));
  };

  return (
    <select
      data-testid="DraftLegAddButton"
      id="DraftLegAddButton"
      value=""
      title="Add a leg"
      onChange={(e) => {
        if (e.target.value) handleAdd(e.target.value as TicketInstrument);
      }}
      className="h-[28px] rounded-md border border-gray-300 px-2 text-xs font-semibold outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200"
    >
      <option value="">+ Leg</option>
      {returnTicketInstruments(true).map((instrument) => (
        <option key={instrument} value={instrument}>
          {instrument}
        </option>
      ))}
    </select>
  );
};

export default DraftLegAddButton;
